module.exports = "/_next/static/images/Connections@2x-9336e52d07f8917f805ca53db387403a.png";